<template>
  <div class="masked relative flex items-center justify-center">
    <slot />
    <svg
      width="0"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      class="absolute inset-0 block h-full w-full"
    >
      <defs>
        <path
          :id="pathDefId"
          :d="actualShape"
          :transform="`translate(${translate} ${translate}) scale(${scale} ${scale})`"
        >
          <animateTransform
            v-if="animation == 'spin'"
            begin="0s"
            attributeName="transform"
            type="rotate"
            :dur="animationDuration"
            repeatCount="indefinite"
            calcMode="spline"
            values="0 0 0; 180 0 0; 360 0 0"
            keyTimes="0; 0.5; 1"
            keySplines="0.4 0.2 0.6 0.8; 0.4 0.2 0.6 0.8"
            additive="sum"
          />
          <animateTransform
            v-if="animation == 'scale'"
            begin="0s"
            attributeName="transform"
            type="scale"
            :dur="animationDuration"
            repeatCount="indefinite"
            calcMode="spline"
            :values="scaleAnimationTransform"
            keyTimes="0; 0.5; 1"
            keySplines="0.4 0.2 0.6 0.8; 0.4 0.2 0.6 0.8"
            additive="sum"
          />
        </path>
        <clipPath :id="maskId" clipPathUnits="objectBoundingBox" transform="scale(0.01 0.01)">
          <use :href="`#${pathDefId}`" />
        </clipPath>
      </defs>
      <use
        v-if="stroke"
        :href="`#${pathDefId}`"
        :class="`stroke-${stroke.color} h-full w-full`"
        fill="none"
        :stroke-width="stroke.width"
      />
    </svg>
  </div>
</template>
<script setup lang="ts">
  import { computed, useId } from 'vue'
  import { shapePaths, type Shape } from './shape-paths'

  const {
    shape,
    scale = 1,
    translate = 50,
    animationDuration = '5s',
    scaleAnimationTransform = '1; 1.3; 1',
  } = defineProps<{
    shape: Shape
    scale?: number
    translate?: number
    scaleAnimationTransform?: string
    animationDuration?: string
    animation?: 'spin' | 'scale'
    stroke?: { width: number; color: string }
  }>()

  const maskId = useId()
  const pathDefId = useId()
  const maskUrl = `url('#${maskId}')`

  const actualShape = computed(() => {
    return shapePaths[shape]
  })
</script>
<style scoped>
  .masked {
    clip-path: v-bind(maskUrl);
    filter: drop-shadow(-1px 6px 3px rgba(50, 50, 0, 0.5));
  }
</style>
